import { render, staticRenderFns } from "./ManageProductDetail.vue?vue&type=template&id=326be98a&scoped=true&"
import script from "./ManageProductDetail.vue?vue&type=script&lang=js&"
export * from "./ManageProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageProductDetail.vue?vue&type=style&index=0&id=326be98a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326be98a",
  null
  
)

export default component.exports